import _ from "lodash";
import { path } from "../../api";
import { restClient, restClientAll } from "../../utils/restClient";
import moment from "moment-timezone";
import { DATE_FORMAT } from "../../utils/utils";

const initialState = {};

export default {
  namespaced: true,
  name: "buy",
  state: _.cloneDeep(initialState),
  actions: {
    async decodeUrlForCart(_, payload = null) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClientAll(
            path.client.decodeLotteries,
            "POST",
            null,
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async fetchLotteries(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.lotteries.base,
            "GET",
            null,
            payload
          );

          if (response && response.data) {
            const now = moment().tz(
              DATE_FORMAT.TIMEZONE || "America/Santo_Domingo"
            );
            let dataToFilter = Array.isArray(response.data)
              ? response.data
              : response.data.data || [];

            const filteredData = dataToFilter.filter((lottery) => {
              const rdTz = DATE_FORMAT.TIMEZONE || "America/Santo_Domingo";
              const tz = lottery.timezone || rdTz;
              const baseDate =
                lottery.sale_date || moment().tz(tz).format("YYYY-MM-DD");

              let dateInTz = moment.tz(
                `${baseDate} ${lottery.today_end_time}`,
                "YYYY-MM-DD HH:mm:ss",
                tz
              );

              // If end_time is in early morning (00:00:01 - 04:00:00), it's an overnight draw closing on the next calendar day of its sale_date
              if (
                lottery.today_end_time > "00:00:00" &&
                lottery.today_end_time <= "04:00:00" &&
                (lottery.sale_date || now.format("HH:mm:ss") >= "04:00:00")
              ) {
                dateInTz.add(1, "days");
              }

              const date = dateInTz.clone().tz(rdTz);

              return !date.isBefore(now);
            });

            if (Array.isArray(response.data)) {
              response.data = filteredData;
            } else if (response.data.data) {
              response.data.data = filteredData;
            }
          }

          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async processTicket(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.orders.buy,
            "POST",
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
